import { apiClient } from './api';
import { AuthResponse, User } from '../types/auth';

export const authService = {
  async login(email: string, password: string): Promise<AuthResponse> {
    try {
      const response = await apiClient.post<AuthResponse>('/auth/login', {
        email,
        password,
      });
      
      return response.data;
    } catch (error: unknown) {
      throw error;
    }
  },

  async register(name: string, email: string, password: string): Promise<AuthResponse> {
    try {
      const response = await apiClient.post<AuthResponse>('/auth/register', {
        name,
        email,
        password,
      });
      
      return response.data;
    } catch (error: unknown) {
      throw error;
    }
  },

  async logout(): Promise<void> {
    try {
      await apiClient.post('/auth/logout');
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Erreur lors de la déconnexion:', error);
      }
    }
  },

  async getCurrentUser(): Promise<User> {
    try {
      const response = await apiClient.get('/user');
      
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      
      if (response.data.id && response.data.email && response.data.name) {
        return response.data as User;
      }
      
      throw new Error('Format de réponse inattendu');
    } catch (error: unknown) {
      if (process.env.NODE_ENV === 'development') {
        const axiosErr = error as { response?: { data?: unknown }; message?: string };
        console.error('Erreur getCurrentUser:', axiosErr.response?.data || axiosErr.message);
      }
      throw error;
    }
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('auth_token');
  },
};
